<template>
  <div class="app">
    <Card dis-hover>
      <div class="page-body">
        <Form ref="queryForm" :label-width="90" label-position="right" inline>
          <Row :gutter="16">
            <Col span="4">
            <FormItem label="记录编号:" :label-width="70" style="width: 100%">
              <Input v-model="query.record" placeholder="请输入记录编号"></Input>
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem label="物料名称:" :label-width="70" style="width: 100%">
              <Input v-model="query.material" placeholder="请输入物料名称"></Input>
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem label="责任部门:" :label-width="70" style="width: 100%">
              <Input v-model="query.accountabilityUnit" placeholder="请输入责任部门"></Input>
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem label="责任人:" :label-width="70" style="width: 100%">
              <Input v-model="query.accountabilityUser" placeholder="请输入责任人"></Input>
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem prop="rangeTime" :label-width="70" label="发生时间:" style="width: 100%">
              <DatePicker v-model="query.rangeTime" type="daterange" format="yyyy-MM-dd" style="width: 100%" placement="bottom-end" placeholder="请选择发生时间"></DatePicker>
            </FormItem>
            </Col>
            <!-- <Col span="4">
            <FormItem label="不合格品类型:" style="width: 100%">
              <Select v-model="query.type" placeholder="请选择类型">
                <Option value=" ">------</Option>
                <Option v-for="(item, index) in productTypeList" :key="index" :value="item.value">
                  {{ item.name }}
                </Option>
              </Select>
            </FormItem>
            </Col>
            <Col span="4">
            <FormItem label="状态:" :label-width="70" style="width: 100%">
              <Select v-model="query.status"  placeholder="请选择状态">
                <Option value=" ">------</Option>
                <Option v-for="item in statusList" :key="item.value" :value="item.value">
                  {{ item.name }}
                </Option>
              </Select>
            </FormItem>
            </Col> -->
            <FormItem :label-width="10" style="width: 100%">
              <Button icon="ios-search" type="primary" size="default" @click="getpage(1)" class="toolbar-btn">{{ '查询' }}</Button>
            </FormItem>
          </Row>
        </Form>
        <div v-if="list">
          <Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list"></Table>
          <Page show-total show-sizer class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="pageSize" :current="currentPage"></Page>
        </div>
      </div>
    </Card>
    <Spin fix v-show="gLoading">
      <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>加载中</div>
    </Spin>
    <Detail v-model="detailModalShow" :infoData="info" v-if="isGetData" @loadingChange="loadingChange" @succesConfirm="closeModal" @save-success="getpage" />
   
  </div>
</template>

<script>
import Detail from './supplierDetail.vue'
import Print from './print.vue'
import Util from '../../../lib/util'
export default {
  name: 'bomuploadBySupplier',
  data() {
    return {
      query: {
        record: '',
        material: '',
        type: 1,
        rangeTime: '',
        status: '',
        accountabilityUser: '',
        accountabilityUnit: '',
      },
      list: [],
      productTypeList: [],
      statusList: [],
      info: null,
      isGetData: false,
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      loading: false,
      detailModalShow: false,
      columns: [],
      gLoading: false,
    }
  },
  components: {
    Detail,
    Print,
  },
  methods: {
    async getInit() {
      const data = await this.$Ajax(
        '/api/services/app/UnacceptedProductProcessOrder/QueryDtoByCGBOrSupplier'
      )
      this.productTypeList = data.data.result.productTypeList
      this.statusList = data.data.result.statusList
      this.getpage()
    },
    async getpage(params) {
      // SkipCount 跳过多少条数据
      // MaxResultCount 每次最多返回多少条
      if (params == 1) {
        this.currentPage = 1
      }
      let str = `/api/services/app/UnacceptedProductProcessOrder/QueryDtoByCGBOrSupplier?IncludeSelectItem=true&MaxResultCount=${
        this.pageSize
      }&SkipCount=${(this.currentPage - 1) * this.pageSize}&AccountabilityUser=${
        this.query.accountabilityUser
      }&AccountabilityUnit=${this.query.accountabilityUnit}`
      if (this.query.record) {
        str += `&RecordNumber=${this.query.record}`
      }
      if (this.query.material) {
        str += `&MaterialName=${this.query.material}`
      }
      if (this.query.type) {
        str += `&ProductType=${this.query.type}`
      }
      if (this.query.status) {
        str += `&Status=${this.query.status}`
      }
      if (this.query.rangeTime[0]) {
        let OccurrenceTimeStart = this.formatDate(this.query.rangeTime[0])
        let OccurrenceTimeEnd = this.formatDate(this.query.rangeTime[1])
        str += `&OccurrenceTimeStart=${OccurrenceTimeStart}&OccurrenceTimeEnd=${OccurrenceTimeEnd}`
      }
      this.loading = true
      const data = await this.$Ajax.get(str)
      this.list = data.data.result.items
      this.totalCount = data.data.result.totalCount
      this.loading = false
    },
    formatDate(datetime) {
      let date = new Date(datetime)
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      return y + '-' + m + '-' + d
    },
    pageChange(page) {
      this.currentPage = page
      this.getpage()
      //重新渲染页面
    },
    pagesizeChange(pagesize) {
      this.pageSize = pagesize
      this.getpage()
      //重新渲染页面
    },
    closeModal(value) {
      this.detailModalShow = value
      this.isGetData = false
    },
    closePrintModal() {
      this.printModalShow = true
      this.isShowPrint = false
    },
    loadingChange() {
      this.gLoading = !this.gLoading
    },
    getColumns() {
      let _this = this
      this.columns = [
        {
          title: '记录编号',
          key: 'recordNumber',
          width: 144,
        },
        {
          title: '类型',
          key: 'productType_Text',
          width: 100,
        },
        {
          title: '物料名称',
          key: 'materialName',
          width: 120,
        },
        {
          title: '图号/物料编码',
          key: 'materialCode',
          minWidth: 140,
        },
        {
          title: '责任单位/部门',
          key: 'accountabilityUnit',
          minWidth: 80,
          maxWidth: 120,
        },
        {
          title: '责任人',
          key: 'accountabilityUser',
          width: 90,
        },
        {
          title: '不良类别',
          key: 'undesirableCategoryText',
          width: 90,
          // render:(h,params) => {
          //     return h("span", params.row.selectItem.name)
          // }
        },
        {
          title: '填写人',
          key: 'writtenUser',
          width: 90,
        },
        {
          title: '发生时间',
          key: 'occurrenceTimeText',
          width: 140,
        },
        {
          title: '提交时间',
          key: 'submitText',
          width: 140,
        },
        {
          title: '完成时间',
          key: 'finishTimeText',
          width: 140,
        },
        {
          title: '状态',
          key: 'statusText',
          minWidth: 110,
        },
        {
          title: '操作',
          align: 'center',
          width: 180,
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      _this.info = params.row.id
                      _this.isGetData = true //控制数据传输给detail组件
                      // console.log('row',params.row)//打印出来就是初始结果
                      _this.detailModalShow = true
                    },
                  },
                },
                params.row.status == _this.$constDefinition.completed ? '详情' : '操作'
              ),
           
            
            ])
          },
        },
      ]
    },

  },
  mounted() {
    this.query.record = this.$route.query.workName
    this.getInit()
    this.getColumns()
  },
}
</script>

<style lang="less" scoped>
.app {
  min-width: 1260px;
}
.modal-cont /deep/ .ivu-modal-body {
  font-size: 20px;
  text-align: center;
}
.modal-cont /deep/ .ivu-modal {
  top: 300px;
}
/deep/.ivu-modal-footer {
  text-align: center;
}
</style>
